import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output, signal, DOCUMENT } from '@angular/core';
import { tap, finalize, catchError, of, Subject, takeUntil } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '@auth0/auth0-angular';

import { Router } from '@angular/router';

import { UserPermissionResponseModel } from '../../core/models/responses/user-permission-response.model';
import { HubspotInterestRequest } from '../../core/models/requests/hubspot-interest-request.model';

import { PermissionBaseComponent } from '../../core/abstracts/permission-base.component';

import { PharmasyncService } from '../../core/components/pharma-sync/service/pharmasync.service';
import { PermissionService } from '../../core/services/common/permission.service';
import { AuthGuardService } from '../../core/services/common/auth-guard.service';
import { CookiesService } from '../../core/services/common/cookies.service';
import { EventsService } from '../../core/services/common/events.service';
import { CnpjService } from '../../core/services/common/cnpj.service';
import { ApiService } from '../../core/api/api.service';
import { OnboardService } from '../../core/services/common/onboard.service';
import { SmartpedService } from '../../core/services/common/smartped.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss',
    standalone: false
})
export class MenuComponent extends PermissionBaseComponent implements OnInit, OnDestroy {
  override destroy$ = new Subject<void>();

  @Output() closeMenu = new EventEmitter<boolean>();
  @Output() incentivePoints = new EventEmitter<string>();

  userPermissionResponse: UserPermissionResponseModel = {} as UserPermissionResponseModel;
  isEmailRmFarma: boolean = false;
  isLoading: boolean = false;

  showToast: boolean = false;
  isErrorToast: boolean = false;
  toastMessage: string = '';

  public loading = {
    sendInterest: false
  }

  constructor(
    @Inject(DOCUMENT) public document: Document,
    private authGuardService: AuthGuardService,
    permissionService: PermissionService,
    private eventService: EventsService,
    private cookies: CookiesService,
    private auth0: AuthService,
    public pharmaSyncService: PharmasyncService,
    private cnpjService: CnpjService,
    private apiService: ApiService,
    private router: Router,
    public onboardService: OnboardService
  ) {
    super(permissionService);
  }

  override ngOnInit(): void {
    this.getUserPermission();
    this.checkFreemiumStatus();
    this.checkInternoStatus();
    this.subscribeToEmailDomainCheck();
  }

  override ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleCloseMenu(): void {
    this.closeMenu.emit(false);
  }

  private subscribeToEmailDomainCheck(): void {
    this.authGuardService.isEmailDomainRmFarma().subscribe(isRmFarma => {
      this.isEmailRmFarma = isRmFarma;
    });
  }

  /**
   * Aqui buscamos as permissões do usuário, recentemente foi adicionado o contador de incentivo de pontos e status de 
   * instalação do pharmasync na farmácia nesse mesmo endpoint
   */
  private getUserPermission(): void {
    this.isLoading = true;

    this.permissionService.getUserPermission()
      .pipe(
        tap((response) => {
          this.userPermissionResponse = response;
          this.incentivePoints.emit(response.data.points);
          this.pharmaSyncService.checkPharmaSync(this.userPermissionResponse);
        }),
        finalize(() => this.isLoading = false),
        catchError((error) => {
          console.error('Erro ao buscar permissão', error);
          return of(null);
        })
      )
      .subscribe();
  }

  logout(): void {
    this.cookies.removeItem('TOKEN', '/');
    this.cookies.removeItem('TOKEN');
    this.cookies.clearCookies();
    localStorage.removeItem('CNPJ');
    localStorage.removeItem('CNPJ_NAME');
    localStorage.removeItem('savedHref');
    localStorage.removeItem('savedLocation');
    localStorage.removeItem('utm_params');
    this.eventService.rudderAnalytics?.reset();

    this.auth0.logout({
      logoutParams: {
        returnTo: this.document.location.origin
      }
    });
  }

  sendLeadHubSpot(): void {
    this.loading.sendInterest = true;

    this.auth0.user$.subscribe({
      next: (user) => {
        this.cnpjService.getCnpjs().subscribe({
          next: (cnpj) => {
            const req: HubspotInterestRequest = {
              email: user?.email || "",
              cnpj: cnpj.data[0].cnpj
            }

            this.eventService.eventTrack('CLICK_QUERO_SER_LICENCIADO', { email: user?.email || "" });


            this.apiService.interest(req).pipe(
              takeUntil(this.destroy$),
              tap(() => {
                this.handleSuccessLead();
                this.shouldShowToast();
              }),
              finalize(() => {
                this.loading.sendInterest = false;
                this.router.navigate(['/termos']);
              }),
              catchError((error: HttpErrorResponse) => {
                console.error('Error ao criar lead', error);
                this.handleErrorLead('Desculpe, tente novamente mais tarde!');
                return of(null);
              })
            ).subscribe()
          }
        })
      }
    })
  }

  private handleSuccessLead(): void {
    this.isErrorToast = false;
    this.showToast = true;
    this.shouldShowToast();
    this.messageToast('Nossos consultores entrarão em contato com você em breve');
  }

  private handleErrorLead(message: string): void {
    this.isErrorToast = true;
    this.showToast = true;
    this.messageToast(message);
  }

  private messageToast(message: string): void {
    this.toastMessage = message;
    this.shouldShowToast();
  }

  private shouldShowToast(): void {
    setTimeout(() => {
      this.showToast = false;
    }, 10000);
  }

 

}
